import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { products } from '../../data/products';
import ProductImageGallery from '../../components/ProductImageGallery';
import { useCart } from '../../context/CartContext';

const RGBGamingMousePad = () => {
  const navigate = useNavigate();
  const { addToCart } = useCart();
  const [activeTab, setActiveTab] = useState('overview');
  const [currentImage, setCurrentImage] = useState('');
  const [selectedSize, setSelectedSize] = useState('Small');
  const [quantity, setQuantity] = useState(1);
  
  // 获取鼠标垫产品数据
  const mousepad = products.find(p => p.name === 'RGB Gaming Mouse Pad');
  
  // 根据尺寸获取价格
  const getPrice = () => {
    return selectedSize === 'Small' ? 'S$9.90' : 'S$11.90';
  };
  
  const getOriginalPrice = () => {
    return selectedSize === 'Small' ? 'S$12.90' : 'S$14.90';
  };

  // 添加到购物车
  const handleAddToCart = () => {
    const productToAdd = {
      ...mousepad,
      price: getPrice(),
      selectedSize,
      quantity
    };
    addToCart(productToAdd);
  };

  // 立即购买
  const handleBuyNow = () => {
    const productToAdd = {
      ...mousepad,
      price: getPrice(),
      selectedSize,
      quantity
    };
    addToCart(productToAdd);
    navigate('/cart');
  };
  
  // 更多图片
  const additionalImages = [
    "/images/shop-products/rgb-gaming-mousepad/f59e02d9-c2e7-4117-a305-54251a6faeec.jpg",
    "/images/shop-products/rgb-gaming-mousepad/206e9a2a-6f1b-4b66-8b0e-a4b0e080a751.jpg",
    "/images/shop-products/rgb-gaming-mousepad/576d2d14-bffd-4a91-806b-860cc2668def.jpg",
    "/images/shop-products/rgb-gaming-mousepad/64cd788c-0c7d-4907-b098-2eeb26449b82.jpg",
    "/images/shop-products/rgb-gaming-mousepad/66800817-728e-45f2-a57e-777c95bf4fbd.jpg",
    "/images/shop-products/rgb-gaming-mousepad/6710d94b-be1a-4600-908d-344f32809385.jpg",
    "/images/shop-products/rgb-gaming-mousepad/8be92b6e-5b2b-444c-903b-8e8ccd52ddf2.jpg",
    "/images/shop-products/rgb-gaming-mousepad/9c43bbc3-685b-49b3-9f86-e7baadeced97.jpg",
    "/images/shop-products/rgb-gaming-mousepad/aef9cf1a-572f-44a2-849d-fb8f47a29174.jpg",
    "/images/shop-products/rgb-gaming-mousepad/c3b9739f-42ac-4c64-8ca5-1fe3fb3b0cd8.jpg",
    "/images/shop-products/rgb-gaming-mousepad/ccbfa3c3-fddb-430f-ad71-caf3baced2ec.jpg",
    "/images/shop-products/rgb-gaming-mousepad/d6eb341d-dc97-4a7e-88ce-d739c3f097f8.jpg",
    "/images/shop-products/rgb-gaming-mousepad/f488ebde-a99f-4ed8-a5b4-51487870f41a.jpg",
    "/images/shop-products/rgb-gaming-mousepad/f59e02d9-c2e7-4117-a305-54251a6faeec.jpg",
    "/images/shop-products/rgb-gaming-mousepad/f76af9ac-5c36-4749-9bbb-e9b2ea78d48e.jpg",
    "/images/shop-products/rgb-gaming-mousepad/f8baed5e-53bf-4363-98b4-1761a7286635.jpg"
  ];

  // 初始化当前图片
  useEffect(() => {
    setCurrentImage(mousepad.image);
  }, [mousepad.image]);

  // 相关产品
  const relatedProducts = products.filter(p => 
    p.name !== 'RGB Gaming Mouse Pad' && 
    (p.category === 'accessories' || p.category === 'mice')
  ).slice(0, 4);

  return (
    <div className="container mx-auto px-4 py-12 text-white">
      {/* 面包屑导航 */}
      <div className="text-sm text-gray-400 mb-6">
        <Link to="/" className="hover:text-white">Home</Link> / 
        <Link to="/shop" className="hover:text-white mx-2">Shop</Link> / 
        <Link to="/shop/nintendo-accessories" className="hover:text-white mr-2">Nintendo Accessories</Link> / 
        <span className="text-white">{mousepad.name}</span>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
        {/* 左侧产品图片 */}
        <div>
          <ProductImageGallery
            images={additionalImages}
            currentImage={currentImage}
            onImageChange={setCurrentImage}
          />
        </div>
        
        {/* 右侧产品信息 */}
        <div>
          <h1 className="text-3xl font-bold mb-2">{mousepad.name}</h1>
          
          {/* 评分 */}
          <div className="flex items-center mb-4">
            <div className="flex text-yellow-400">
              {[...Array(5)].map((_, i) => (
                <span key={i} className={i < Math.floor(mousepad.rating) ? "text-yellow-400" : "text-gray-600"}>★</span>
              ))}
            </div>
            <span className="ml-2 text-gray-400">({mousepad.reviews} reviews)</span>
          </div>
          
          {/* 价格 */}
          <div className="mb-6">
            <span className="text-3xl font-bold">{getPrice()}</span>
            <span className="ml-3 text-gray-400 line-through">{getOriginalPrice()}</span>
            <span className="ml-3 bg-red-600 text-white px-2 py-1 rounded-md text-sm">
              Save S${(parseFloat(getOriginalPrice().replace(/^S\$/, '')) - parseFloat(getPrice().replace(/^S\$/, ''))).toFixed(2)}
            </span>
          </div>
          
          {/* 库存状态 */}
          <div className="mb-6">
            {mousepad.inStock ? (
              <span className="text-green-500 flex items-center">
                <svg className="w-5 h-5 mr-1" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
                In Stock
              </span>
            ) : (
              <span className="text-red-500 flex items-center">
                <svg className="w-5 h-5 mr-1" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                </svg>
                Out of Stock
              </span>
            )}
          </div>
          
          {/* 简短描述 */}
          <p className="text-gray-300 mb-6">{mousepad.description}</p>
          
          {/* 选择尺寸 */}
          <div className="mb-6">
            <h3 className="text-lg font-medium mb-3">Size</h3>
            <div className="grid grid-cols-2 gap-3">
              {[
                { name: 'Small', dimensions: '350x250x4mm', price: 'S$9.90' },
                { name: 'Big', dimensions: '800x300x4mm', price: 'S$11.90' }
              ].map((size) => (
                <button 
                  key={size.name}
                  className={`border-2 ${size.name === selectedSize ? 'border-green-500' : 'border-gray-700'} 
                    rounded-md py-3 px-4 text-center hover:border-green-500 transition-colors`}
                  onClick={() => setSelectedSize(size.name)}
                >
                  <div className="font-medium">{size.name}</div>
                  <div className="text-sm text-gray-400">{size.dimensions}</div>
                  <div className="text-sm text-green-400 font-bold">{size.price}</div>
                </button>
              ))}
            </div>
          </div>
          
          
          {/* Quantity */}
          <div className="mb-8">
            <h3 className="text-lg font-medium mb-3">Quantity</h3>
            <div className="flex items-center">
              <button 
                className="bg-gray-800 px-4 py-2 rounded-l-md"
                onClick={() => setQuantity(Math.max(1, quantity - 1))}
              >
                -
              </button>
              <input 
                type="text" 
                value={quantity} 
                readOnly
                className="bg-gray-800 text-center w-16 py-2 border-x border-gray-700"
              />
              <button 
                className="bg-gray-800 px-4 py-2 rounded-r-md"
                onClick={() => setQuantity(quantity + 1)}
              >
                +
              </button>
            </div>
          </div>
          
          {/* Purchase Buttons */}
          <div className="grid grid-cols-2 gap-4 mb-6">
            <button 
              onClick={handleAddToCart}
              className="bg-green-600 hover:bg-green-700 text-white py-3 px-6 rounded-md font-medium"
            >
              Add to Cart
            </button>
            <button 
              onClick={handleBuyNow}
              className="bg-gray-800 hover:bg-gray-700 text-white py-3 px-6 rounded-md font-medium border border-gray-600"
            >
              Buy Now
            </button>
          </div>
          
          {/* Shipping Info */}
          <div className="border-t border-gray-700 pt-6">
            <div className="flex items-center mb-3">
              <svg className="w-5 h-5 mr-2 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                <path d="M8 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM15 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" />
                <path d="M3 4a1 1 0 00-1 1v10a1 1 0 001 1h1.05a2.5 2.5 0 014.9 0H10a1 1 0 001-1v-5h2a1 1 0 00.9-.5l1.5-2A1 1 0 0015 7h-3V4a1 1 0 00-1-1H3zM14 7l-1.5 2H10V5h4v2z" />
              </svg>
              <span className="text-gray-300">Free Meet Up (Available at Sengkang & Orchard locations)</span>
            </div>
            <div className="flex items-center">
              <svg className="w-5 h-5 mr-2 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
              </svg>
              <span className="text-gray-300">Available Shipping</span>
            </div>
          </div>
        </div>
      </div>
      
      {/* 产品详情选项卡 */}
      <div className="mt-16">
        <div className="border-b border-gray-700 mb-8">
          <div className="flex space-x-8">
            <button 
              onClick={() => setActiveTab('overview')}
              className={`pb-4 px-2 font-medium ${activeTab === 'overview' ? 'text-white border-b-2 border-green-500' : 'text-gray-400'}`}
            >
              Overview
            </button>
            <button 
              onClick={() => setActiveTab('specs')}
              className={`pb-4 px-2 font-medium ${activeTab === 'specs' ? 'text-white border-b-2 border-green-500' : 'text-gray-400'}`}
            >
              Specifications
            </button>
            <button 
              onClick={() => setActiveTab('reviews')}
              className={`pb-4 px-2 font-medium ${activeTab === 'reviews' ? 'text-white border-b-2 border-green-500' : 'text-gray-400'}`}
            >
              Reviews ({mousepad.reviews})
            </button>
          </div>
        </div>
        
        {/* 选项卡内容 */}
        <div>
          {activeTab === 'overview' && (
            <div>
              <h2 className="text-2xl font-bold mb-6">Product Overview</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
                <div>
                  <p className="text-gray-300 mb-6">
                    The RGB Gaming Mouse Pad combines stunning visual appeal with exceptional performance for 
                    competitive gaming. This premium mouse pad features advanced RGB lighting technology that 
                    creates an immersive gaming atmosphere while providing the perfect surface for precise mouse control.
                  </p>
                  <p className="text-gray-300 mb-6">
                    Made from high-quality materials, the surface offers optimal tracking for gaming mice with 
                    various sensors. The anti-slip rubber base ensures the mouse pad stays firmly in place during 
                    intense gaming sessions, while the stitched edges provide durability and prevent fraying.
                  </p>
                  <p className="text-gray-300">
                    The customizable RGB lighting can be synchronized with your other gaming peripherals for 
                    a cohesive setup. With multiple lighting modes and color options, you can create the perfect 
                    ambiance for your gaming environment.
                  </p>
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-4">Key Features</h3>
                  <ul className="space-y-4">
                    {mousepad.features.map((feature, index) => (
                      <li key={index} className="flex items-start">
                        <svg className="w-6 h-6 mr-2 text-green-500 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                        </svg>
                        <div>
                          <span className="font-medium">{feature}</span>
                          <p className="text-gray-400 text-sm mt-1">
                            {feature === "RGB Lighting" && "16.8 million color options with multiple lighting effects"}
                            {feature === "Anti-Slip Base" && "High-quality rubber base that prevents movement during use"}
                            {feature === "Stitched Edges" && "Durable stitched borders that prevent fraying and extend lifespan"}
                            {feature === "Multiple Sizes" && "Available in small, medium, and large sizes to fit any desk"}
                          </p>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          )}
          
          {activeTab === 'specs' && (
            <div>
              <h2 className="text-2xl font-bold mb-6">Technical Specifications</h2>
              <div className="bg-gray-800 rounded-lg p-6">
                <table className="w-full">
                  <tbody>
                    {Object.entries(mousepad.specs).map(([key, value], index) => (
                      <tr key={index} className={index !== 0 ? "border-t border-gray-700" : ""}>
                        <td className="py-4 pr-4 font-medium w-1/3">{key}</td>
                        <td className="py-4 text-gray-300">{value}</td>
                      </tr>
                    ))}
                    <tr className="border-t border-gray-700">
                      <td className="py-4 pr-4 font-medium">Small Size</td>
                      <td className="py-4 text-gray-300">350 x 250 x 4mm</td>
                    </tr>
                    <tr className="border-t border-gray-700">
                      <td className="py-4 pr-4 font-medium">Big Size</td>
                      <td className="py-4 text-gray-300">800 x 300 x 4mm</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          )}
          
          {activeTab === 'reviews' && (
            <div>
              <h2 className="text-2xl font-bold mb-6">Customer Reviews</h2>
              <div className="flex items-center mb-8">
                <div className="mr-4">
                  <div className="text-5xl font-bold">{mousepad.rating}</div>
                  <div className="flex text-yellow-400 mt-2">
                    {[...Array(5)].map((_, i) => (
                      <span key={i} className={i < Math.floor(mousepad.rating) ? "text-yellow-400" : "text-gray-600"}>★</span>
                    ))}
                  </div>
                  <div className="text-sm text-gray-400 mt-1">Based on {mousepad.reviews} reviews</div>
                </div>
                <div className="flex-1 ml-6">
                  {[5, 4, 3, 2, 1].map((star) => (
                    <div key={star} className="flex items-center mb-2">
                      <div className="w-12 text-sm text-gray-400">{star} stars</div>
                      <div className="w-full bg-gray-700 rounded-full h-2 mx-2">
                        <div 
                          className="bg-yellow-400 h-2 rounded-full" 
                          style={{ 
                            width: `${star === 5 ? 70 : star === 4 ? 20 : star === 3 ? 7 : star === 2 ? 2 : 1}%` 
                          }}
                        ></div>
                      </div>
                      <div className="w-12 text-sm text-right text-gray-400">
                        {star === 5 ? '70%' : star === 4 ? '20%' : star === 3 ? '7%' : star === 2 ? '2%' : '1%'}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              
              {/* 示例评论 */}
              <div className="space-y-6">
                {[
                  { name: "Ryan M.", rating: 5, date: "1 week ago", comment: "This RGB mouse pad is absolutely stunning! The lighting effects are smooth and the surface provides excellent tracking for my gaming mouse. The anti-slip base works perfectly and it looks amazing on my desk." },
                  { name: "Amanda K.", rating: 5, date: "2 weeks ago", comment: "I love the customizable RGB lighting and the quality is top-notch. The stitched edges give it a premium feel and it's the perfect size for my gaming setup. Highly recommend!" },
                  { name: "Tom B.", rating: 4, date: "1 month ago", comment: "Great mouse pad with beautiful RGB lighting. The surface is smooth and responsive. The only minor issue is that the USB cable could be a bit longer, but otherwise it's excellent." }
                ].map((review, index) => (
                  <div key={index} className="border-b border-gray-700 pb-6">
                    <div className="flex justify-between mb-2">
                      <span className="font-medium">{review.name}</span>
                      <span className="text-gray-400 text-sm">{review.date}</span>
                    </div>
                    <div className="flex text-yellow-400 mb-2">
                      {[...Array(5)].map((_, i) => (
                        <span key={i} className={i < review.rating ? "text-yellow-400" : "text-gray-600"}>★</span>
                      ))}
                    </div>
                    <p className="text-gray-300">{review.comment}</p>
                  </div>
                ))}
              </div>
              
              {/* 查看更多评论按钮 */}
              <div className="mt-8 text-center">
                <button className="bg-gray-800 hover:bg-gray-700 text-white py-3 px-6 rounded-md font-medium">
                  Load More Reviews
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
      
      {/* 相关产品 */}
      <div className="mt-20">
        <h2 className="text-2xl font-bold mb-8">You May Also Like</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {relatedProducts.map(product => (
            <div key={product.id} className="bg-gray-800 rounded-lg overflow-hidden">
              <img src={product.image} alt={product.name} className="w-full h-48 object-cover" />
              <div className="p-4">
                <h3 className="font-medium mb-2">{product.name}</h3>
                <div className="flex justify-between items-center">
                  <span className="font-bold">${product.price}</span>
                  <button className="bg-green-600 hover:bg-green-700 text-white py-1 px-3 rounded-md text-sm">
                    View Details
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RGBGamingMousePad;
